import { Key } from './url'

interface PageId {
  pageId: number
  urlKey: Key
}

export const PAGE_ID: PageId[] = [
  {
    pageId: 1,
    urlKey: 'TOP',
  },
  {
    pageId: 2,
    urlKey: 'RISK_MEMBER_DETAIL',
  },
  {
    pageId: 3,
    urlKey: 'RISK_TEAM_DETAIL',
  },
  {
    pageId: 4,
    urlKey: 'SEARCH',
  },
  {
    pageId: 6,
    urlKey: 'TUTORIAL_MASTER',
  },
  {
    pageId: 7,
    urlKey: 'TUTORIAL_MEMBER',
  },
  {
    pageId: 8,
    urlKey: 'RISK_TIMELINE',
  },
  {
    pageId: 9,
    urlKey: 'WORK_STYLE',
  },
]

export default PAGE_ID
